import { render, staticRenderFns } from "./Propio.vue?vue&type=template&id=b166f100"
import script from "./Propio.vue?vue&type=script&lang=js"
export * from "./Propio.vue?vue&type=script&lang=js"
import style0 from "./Propio.vue?vue&type=style&index=0&id=b166f100&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports